export const FEATURE_PRESETS = [
  { key: "scheduling", label: "Scheduling and labor", flags: { scheduling_enabled: true, training_enabled: false, documents_enabled: false, operations_assistant_enabled: true } },
  { key: "training", label: "Training and onboarding", flags: { scheduling_enabled: false, training_enabled: true, documents_enabled: true, operations_assistant_enabled: true } },
  { key: "both", label: "Scheduling and training", flags: { scheduling_enabled: true, training_enabled: true, documents_enabled: true, operations_assistant_enabled: true } },
];

export function isSampleLocation(store) {
  const name = (store.store_name || "").trim().replace(/\s+/g, " ").toLowerCase();
  return ["sample location", "test location"].some(label => name.includes(label));
}

export function featureDraftChanges(data, draft, applyToExisting = false) {
  return Object.fromEntries(Object.entries(draft).filter(([flag, value]) =>
    data.company_flags[flag] !== value || data.stores.some(store => applyToExisting && store.flags[flag] !== value)
  ));
}
